import React, { useRef } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { NewWay } from './components/sections/NewWay';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Situations } from './components/sections/Situations';
import { Solution } from './components/sections/Solution';
import { Volumes } from './components/sections/Volumes';
import { Days } from './components/sections/Days';
import { Extras } from './components/sections/Extras';
import { Results } from './components/sections/Results';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  const firstCtaRef = useRef<HTMLDivElement>(null);
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="6hq1ea16ddl">
      <MetaPixel data-id="element-1" data-mp="2zlli5ahfl0qy" />
      <Hero ctaRef={firstCtaRef} data-id="element-2" data-mp="2zm4v0cs84yy4" />
      <main data-id="element-3" data-mp="2zn6biws0edn8">
        <NewWay data-id="element-4" data-mp="2znfy0adui2o6" />
        <Problem data-id="element-5" data-mp="33mf623uvifju" />
        <BeforeAfter data-id="element-6" data-mp="33lx0uhq8gqzs" />
        <Situations data-id="element-7" data-mp="33n6yx6x35z6f" />
        <Solution data-id="element-8" data-mp="33orjc3pos1qk" />
        <Volumes data-id="element-9" data-mp="38lrpeemjd4ho" />
        <Days data-id="element-10" data-mp="38l8h7pmotugu" />
        <Extras data-id="element-11" data-mp="38kqce4lym7xb" />
        <Results data-id="element-12" data-mp="38k6ugnwb7jja" />
        <Bonuses data-id="element-13" data-mp="38nunzn1r85y0" />
        <Offer data-id="element-14" data-mp="3dkuufz2inapn" />
        <Guarantee data-id="element-15" data-mp="3dle1ulujigpf" />
        <Testimonials data-id="element-16" data-mp="3dlw6a5rcw18f" />
        <Author data-id="element-17" data-mp="3dmfozootytni" />
        <Faq data-id="element-18" data-mp="3dirvuqnas99b" />
        <FinalCta data-id="element-19" data-mp="nvj53kddcmru" />
      </main>
      <Footer data-id="element-20" data-mp="nwc0jp6vnpuo" />
      <FloatingCta anchorRef={firstCtaRef} data-id="element-21" data-mp="nur6s1se0axv" />
      <PurchasePopup data-id="element-22" data-mp="nxx0jubyo0zx" />
    </div>;
}